import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {GetManufacturerResponse, GetManufacturersResponse} from '../types';

export const getManufacturersMock: GetManufacturersResponse = [
  {
    manufacturerId: '04911c52-e6fc-11ee-bd3d-0242ac120002',
    name: 'Hyundai',
    code: 'HYU',
    isActive: true,
  },
  {
    manufacturerId: '1a886c36-e6fc-11ee-bd3d-0242ac120002',
    name: 'Other',
    code: 'OTH',
    isActive: true,
  },
  {
    manufacturerId: '2f66ff8a-9825-4ddd-b69b-119c262e285c',
    name: 'TEST manufacturer',
    code: 'code',
    isActive: true,
  },
  {
    manufacturerId: '8ca507b2-feb8-4f4d-a84f-9cceb9508f82',
    name: 'Great manufacturer',
    code: 'GRTMN',
    isActive: true,
  },
  {
    manufacturerId: 'a5c08d64-49a0-41d0-ad4b-c3158cd1d421',
    name: 'NEW manufacturer',
    code: '123',
    isActive: true,
  },
  {
    manufacturerId: '5bcba4ab-c8c2-4872-b09a-9490552736d9',
    name: 'Mercedes',
    code: 'MERC',
    isActive: true,
  },
  {
    manufacturerId: '98ae9bd5-a9fe-4dc9-85d2-19c475359d61',
    name: 'PG test',
    code: 'TEST_PG',
    isActive: true,
  },
];

const getManufacturerResponseMock: GetManufacturerResponse = {
  manufacturer: {
    manufacturerId: '2f66ff8a-9825-4ddd-b69b-119c262e285c',
    name: 'TEST manufacturer',
    code: 'code',
    isActive: true,
  },
};

const getManufacturerResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/admin/v1/omnetic-manufacturer/*', () =>
      HttpResponse.json(getManufacturerResponseMock)
    )
  );

const getManufacturersResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/admin/v1/omnetic-manufacturer', () => HttpResponse.json(getManufacturersMock))
  );

export const metadaAdminManufacturerApiMock = {
  getManufacturerResponseInterceptor,
  getManufacturersResponseInterceptor,
};
